import LottoNav from "../LottoNav";
import {lottoMenus} from "../../constants/nav";
import React from "react";


const Lotto12v2Nav = () => <LottoNav menus={lottoMenus('lottery1/12')}/>

export default Lotto12v2Nav;